import ClientListServices from '../ClientListServices';
import {
  APPLY_FILTERS,
  SET_ITEMS,
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },
  async getClientList({ commit, state }) {
    const { items, total } = await ClientListServices.getClientList(state.filters);

    commit(SET_ITEMS, { items, total });
  },
};
